import React from "react";
import "./navbarButton.scss";
import { registerHook, unregisterHook, isClickTo } from "../../store/clickWrapper";
import classnames from "classnames";
import { withRouter } from 'react-router';
import AngleDownIcon from '../../img/icons/BBiconsRozbalit';

class NavbarButton extends React.Component {
    items = undefined;
    opener = undefined;
    mounted = false;
    state = {
        expanded: false
    };

    componentDidMount() {
        this.mounted = true;
        this.hookId = registerHook(this, (click) => {
            if (this.state.expanded && !isClickTo(click, [this.opener, this.items]) && this.mounted) {
                this.setState({ expanded: false });
            }
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.pathname !== this.props.location.pathname) {
            this.setState({ expanded: false });
        }
    }

    componentWillUnmount() {
        this.mounted = false;
        unregisterHook(this.hookId);
    }

    render() {
        return (
            <div className={classnames({ 'navbar-item has-dropdown': true, 'navbar-item-user': this.props.minWidth, 'is-active': this.state.expanded })}>
                <a className='navbar-link is-arrowless' ref={(el) => this.opener = el} onClick={this.handleClick}>
                    {this.props.link}
                    {this.props.noArrow !== true && <div className={classnames('navmenu-svg-wrapper', { 'is-square': localStorage.locales_menu_active_style === 'square' })} style={{ height: '2.5em', width: '2.5em', marginLeft: 'auto' }}>
                        <AngleDownIcon
                            icon='angle-down'
                            className='svg-standard-fill navmenu-svg-arrow'
                            style={{
                                height: '1.5em', width: '1.5em', fill: '#6d6d6d',
                                transform: `scaleY(${this.state.expanded ? -1 : 1})`, transition: 'all .5s ease'
                            }} />
                    </div>}
                </a>
                <div
                    className={classnames(
                        'navbar-dropdown',
                        this.props.dropdownClassname,
                        { 'is-right': this.props.isRight },
                        { 'is-right-on-smaller-desktop': this.props.isRightOnSmallerDesktop }
                    )}
                    ref={(el) => this.items = el}
                >
                    {this.props.dropdown}
                </div>
            </div>
        );
    }

    handleClick = () => {
        if (window.innerWidth <= 992) {
            typeof this.props.toggleMobileMenu === 'function' ? this.props.toggleMobileMenu() : this.setState({ expanded: !this.state.expanded });
        } else {
            this.setState({ expanded: !this.state.expanded });
        }
    }
}

export default withRouter(NavbarButton);